import type { TourConfig } from "~/features/onboarding/types/tour-config";

// AIDEV-NOTE: Tour configuration for introducing practitioners to Clinical Notes (SOAP notes)
// Shared across /practitioner/sessions and /practitioner/clients/:clientId via localStorage

export const clinicalNoteTourConfig: TourConfig = {
    id: "clinical-note-tour",
    page: "/practitioner/sessions",

    welcome: {
        title: "Introducing: Clinical Notes",
        description:
            "Generate structured clinical notes (SOAP format) from any completed session. Save time on documentation while maintaining thorough records.",
        startButtonText: "Show Me",
        skipButtonText: "Maybe Later",
    },

    steps: [
        {
            id: "clinical-note-button",
            targetSelector: "[data-tour-id='clinical-note-button']",
            title: "Clinical Notes",
            content:
                "Click 'Clinical Note' on any session to generate a structured SOAP note. Notes are editable and can be copied or printed for your records.",
            position: "left",
        },
    ],
};
